import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'app-icones-validacao',
  templateUrl: 'icones-validacao.component.html',
  styleUrls: ['./icones-validacao.component.scss'],
})
export class IconeValidacaoComponent {
  @Input() error!: any;
  
  constructor(

  ) {}

}